import { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiMail, FiExternalLink } from "react-icons/fi";
import { useLanguage } from "../../contexts/LanguageContext";
import MewSeedsLogo from "../../assets/MewSeeds_logo_2.png";
import styles from "./Footer.module.css";

const KakaoLoadOne = () => {
    const ins = document.createElement("ins");
    const scr = document.createElement("script");

    ins.className = "kakao_ad_area";
    ins.style = "display:none";
    scr.async = true;
    scr.type = "text/javascript";
    scr.src = "//t1.daumcdn.net/kas/static/ba.min.js";
    ins.setAttribute("data-ad-width", "320");
    ins.setAttribute("data-ad-height", "100");
    ins.setAttribute("data-ad-unit", "DAN-2QMDPFqoZOo3QNra");

    const target = document.querySelector(`.${styles.adBanner}`);
    if (target) {
        target.innerHTML = "";
        target.appendChild(ins);
        target.appendChild(scr);
    }
};

const Footer = () => {
    const { t } = useLanguage();
    useEffect(() => {
        KakaoLoadOne();
    }, []);

    const footerLinks = [
        { href: "/tools", label: t("nav.tools"), external: false },
        { href: "/guide", label: t("nav.guide"), external: false },
        { href: "/about", label: t("nav.about"), external: false },
        { href: "/contact", label: t("nav.contact"), external: false },
        { href: "/privacy", label: t("nav.privacy"), external: false },
        { href: "/terms", label: t("nav.terms"), external: false },
    ];

    const externalLinks = [
        {
            href: "https://minddeck.mewseeds.com",
            label: "MindDeck",
            external: true,
        },
        {
            href: "https://json.mewseeds.com",
            label: "JSON Parser",
            external: true,
        },
    ];

    return (
        <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
            <div className="container mx-auto px-4 lg:px-6 py-8">
                <div className={styles.adBanner}></div>

                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-6 lg:space-y-0">
                    <div className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-6">
                        <div className="flex items-center space-x-2">
                            <img
                                src={MewSeedsLogo}
                                alt="MewSeeds Logo"
                                className="w-48 h-auto object-contain mt-2"
                            />
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="flex flex-wrap gap-4 lg:gap-6">
                        {footerLinks.map((link) => (
                            <Link
                                key={link.href}
                                to={link.href}
                                className="text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 text-sm transition-colors"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>

                {/* External Links */}
                <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
                        <div className="flex flex-wrap gap-4">
                            {externalLinks.map((link) => (
                                <a
                                    key={link.href}
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 text-sm transition-colors flex items-center space-x-1"
                                >
                                    <span>{link.label}</span>
                                    <FiExternalLink className="w-3 h-3" />
                                </a>
                            ))}
                        </div>
                        <Link
                            to="/contact"
                            className="flex items-center space-x-2 text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 text-sm transition-colors"
                        >
                            <FiMail className="w-4 h-4" />
                            <span>{t("nav.contact")}</span>
                        </Link>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
                        <p className="text-gray-600 dark:text-gray-400 text-sm">
                            {t("footer.copyright")}
                        </p>
                        <p className="text-gray-600 dark:text-gray-400 text-sm">
                            {t("footer.madeWith")}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
